import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Checkbox, FormField, FormGroup, Header, Icon, Input, Modal, ModalActions, ModalContent, Popup, Select } from 'semantic-ui-react';
import { getProducts } from '../../../services/products.service';
import DropdownOption from '../../../types/models/DropdownOption';
import { MONTH_OPTIONS } from '../../../utils/dropdownOptions';
import ProspectAppointment from '../../../types/entities/ProspectAppointment';

interface RequestData {
    productId?: string;
    birthDay?: number;
    birthMonth?: number;
    birthYear?: number;
    concreted: boolean;
}

interface SaleCompletedModalProps {
    prospectAppointmentId: string;
    prospectAppointment: ProspectAppointment;
    onSubmit: (event: SyntheticEvent, prospectId: string, payload: any) => void;
}

const SaleCompletedModal = ({ prospectAppointmentId, prospectAppointment, onSubmit }: SaleCompletedModalProps) => {

    const [openModal, setOpenModal] = useState(false);
    const [saleCompletedCheckbox, setSaleCompletedCheckbox] = useState(false);

    const [products, setProducts] = useState<DropdownOption[]>([]);

    const [requestData, setRequestData] = useState<RequestData>({
        productId: prospectAppointment.prospect.product.id,
        concreted: true,
        birthDay: prospectAppointment.prospect.person?.birthDay,
        birthMonth: prospectAppointment.prospect.person?.birthMonth,
        birthYear: prospectAppointment.prospect.person?.birthYear,
    });

    const fetchProducts = async () => {
        try {
            const response = await getProducts(100, 0);
            const productsList = response?.data.content.map(
                (product: any) => {
                    return {
                        key: product["id"],
                        value: product["id"],
                        text: `${product["sku"]} - ${product["name"]}`,
                    };
                }
            );
            setProducts(productsList);
        } catch (error) {
            console.error("Error al obtener la lista de asesores:", error);
        }
    };

    useEffect(() => {
        if (openModal) {
            fetchProducts();
            setRequestData({
                productId: prospectAppointment.prospect.product.id,
                concreted: true,
                birthDay: prospectAppointment.prospect.person?.birthDay,
                birthMonth: prospectAppointment.prospect.person?.birthMonth,
                birthYear: prospectAppointment.prospect.person?.birthYear,
            });
        }
        // eslint-disable-next-line
    }, [openModal]);

    const handleChange = (e: any, { name, value }: any) => {
        setRequestData({
            ...requestData,
            [name]: value ?? "",
        } as RequestData);
    };

    const handleOpenModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(true);
    };

    const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    return (
        <>
            <Modal
                closeOnDimmerClick
                closeIcon={true}
                size="small"
                onClose={(event) => handleCancelModal(event)}
                open={openModal}
                trigger={
                    <Popup
                        trigger={
                            <Button color="green" icon size="mini" onClick={(event) => handleOpenModal(event)}>
                                <Icon name="check" />
                            </Button>
                        }
                        content='Venta concretada'
                        position='top center'
                        size='small'
                        inverted
                    />
                } >
                <Header icon="check" content="Venta concretada" />
                <ModalContent>

                    <p>¿Estas seguro que la venta ha sido concretada y el producto seleccionado es el correcto? Una vez que hayas realizado este paso, no podras volver atras.</p>

                    <div className="ui form">
                        <FormField
                            control={Select}
                            label={<label htmlFor="form-select-control-advisor">Producto</label>}
                            options={products}
                            placeholder="Selecciona una opcion"
                            name="productId"
                            value={requestData.productId}
                            onChange={handleChange}
                            required
                            search
                            searchInput={{ id: "form-select-control-advisor" }}
                            clearable
                        />

                        <FormGroup>
                            <FormField
                                width={4}
                                control={Input}
                                type='number'
                                min='1'
                                max='31'
                                label='Dia'
                                name="birthDay"
                                placeholder='Cumpleaños'
                                value={requestData.birthDay}
                                onChange={handleChange}
                            />
                            <FormField
                                width={8}
                                control={Select}
                                label='Mes de cumpleaños'
                                options={MONTH_OPTIONS}
                                placeholder='Mes de cumpleaños'
                                name="birthMonth"
                                value={requestData.birthMonth}
                                onChange={handleChange}
                                clearable
                            />
                            <FormField
                                width={4}
                                control={Input}
                                type='number'
                                min='1'
                                max='9999'
                                label='Año'
                                placeholder='Año de nacimiento'
                                name="birthYear"
                                value={requestData.birthYear}
                                onChange={handleChange}
                            />
                        </FormGroup>

                        <FormField>
                            <Checkbox
                                label="Confirmo que la venta ha sido concretada."
                                checked={saleCompletedCheckbox}
                                onChange={(event, data) => setSaleCompletedCheckbox(saleCompletedCheckbox ? false : true)}
                            />
                        </FormField>
                    </div>
                </ModalContent>
                <ModalActions>
                    <Button onClick={(event) => handleCancelModal(event)}>
                        <Icon name="cancel" /> Cancelar
                    </Button>
                    <Button color="green" onClick={(event) => onSubmit(event, prospectAppointmentId, requestData)} disabled={!saleCompletedCheckbox}>
                        <Icon name="checkmark" /> Aceptar
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
};

export default SaleCompletedModal;
